import React, { useEffect, useState } from "react";
import { Modal, Typography, Button, Divider } from "antd";
import {
  RocketOutlined,
  BugOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";

const { Title, Paragraph, Text } = Typography;

const STORAGE_KEY_PREFIX = "onboarding_shown_";

function getStorageKey(userId) {
  return `${STORAGE_KEY_PREFIX}${userId}`;
}

export default function OnboardingModal() {
  const { t } = useTranslation();
  const { user, loading } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (loading || !user?.id) return;

    const key = getStorageKey(user.id);
    const alreadyShown = localStorage.getItem(key);

    if (!alreadyShown) {
      setOpen(true);
    }
  }, [user, loading]);

  const handleClose = () => {
    if (user?.id) {
      localStorage.setItem(getStorageKey(user.id), "true");
    }
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      centered
      width={600}
      closable
    >
      <div style={{ textAlign: "center", padding: "8px 0 16px" }}>
        <RocketOutlined style={{ fontSize: 48, color: "#183B75" }} />
        <Title level={2} style={{ marginTop: 16, marginBottom: 4 }}>
          {t("onboarding.welcomeTitle")}
        </Title>
        <Text type="secondary" style={{ fontSize: 15 }}>
          {t("onboarding.subtitle")}
        </Text>
      </div>

      <Divider />

      <Paragraph style={{ fontSize: 15 }}>
        <ExperimentOutlined style={{ color: "#183B75", marginRight: 8 }} />
        <Text strong>{t("onboarding.whatIsThis")}</Text>
      </Paragraph>
      <Paragraph style={{ color: "#444", lineHeight: 1.7 }}>
        {t("onboarding.platformDescription")}
      </Paragraph>

      <Paragraph style={{ fontSize: 15, marginTop: 16 }}>
        <BugOutlined style={{ color: "#183B75", marginRight: 8 }} />
        <Text strong>{t("onboarding.feedbackTitle")}</Text>
      </Paragraph>
      <Paragraph style={{ color: "#444", lineHeight: 1.7 }}>
        {t("onboarding.feedbackDescription")}
      </Paragraph>

      <div style={{ textAlign: "center", marginTop: 24 }}>
        <Button
          type="primary"
          size="large"
          icon={<RocketOutlined />}
          onClick={handleClose}
          style={{
            background: "#183B75",
            borderColor: "#183B75",
            minWidth: 180,
          }}
        >
          {t("onboarding.getStarted")}
        </Button>
      </div>
    </Modal>
  );
}
